import { IMouseNavigatorParameters } from '@3d-scene/mousenavigatorparameters/i-mouse-navigator-parameters';
import { ProjectType } from '@project/model/project-type';
import { ConfiguratorParameters } from '../configurator-parameters/configurator-parameters';
import { DeviceUtils } from '@shared/util/device-utils';
import { EPS } from '../common/scene/controls/camera-controls-constants';
import { assertExhaustiveSwitch } from '@shared/util/ts-utils';

export function getMouseNavigationParameters(projectType: ProjectType | undefined): IMouseNavigatorParameters {
  if (!projectType) {
    return defaultMouseNavigatorParameters
  }
  switch (projectType) {
    case 'MCS':
    case 'GDS':
    case 'LTL':
    case 'SPLICING_CONNECTOR_221':
      return projectsWithBaseArticleMouseNavigatorParameters;
    case 'MOUNTING_RAIL':
    case 'FREE_MOUNTING':
    case 'CIRCUIT_BOARD':
    case 'SPEEDWAY':
      return mountingRailMouseNavigatorParameters;
    case 'MARKINGSYSTEM':
      return markingSystemMouseNavigatorParameters;
    case 'ADMIN':
      return adminToolMouseNavigatorParameters;
    case 'XCOM':
      return xComMouseNavigatorParameters;
    default:
      assertExhaustiveSwitch(projectType);
  }
}

const defaultMouseNavigatorParameters: IMouseNavigatorParameters = {
    offsetDistance: NaN,
    defaultDistance: ConfiguratorParameters.view.cameraDefaultDistance,
    defaultDistancePdfCameraParameter: ConfiguratorParameters.view.cameraDefaultDistancePdfCameraParameter,
    defaultTiltAngle: ConfiguratorParameters.view.cameraDefaultTilt,
    defaultOrbitAngle: ConfiguratorParameters.view.cameraDefaultPan,
};

const adminToolMouseNavigatorParameters: IMouseNavigatorParameters = {
    offsetDistance: 0,
    defaultDistance: 0.85,
    defaultDistancePdfCameraParameter: 1600,
    defaultTiltAngle: 35.27122061,
    defaultOrbitAngle: 315,
    isViewAllInDefaultPositionRequired: true,
};

const markingSystemMouseNavigatorParameters: IMouseNavigatorParameters = {
    offsetDistance: 0,
    defaultDistance: 0.5,
    defaultDistancePdfCameraParameter: 1600,
    defaultTiltAngle: 90,
    defaultOrbitAngle: 180,
    isViewAllInDefaultPositionRequired: false,
};

const projectsWithBaseArticleMouseNavigatorParameters: IMouseNavigatorParameters = {
    offsetDistance: 0,
    defaultDistance: DeviceUtils.isMobile() ? 0.85 : 1.3,
    defaultDistancePdfCameraParameter: 1600,
    defaultTiltAngle: 35.27122061,
    defaultOrbitAngle: 135,
    isViewAllInDefaultPositionRequired: true,
};

const mountingRailMouseNavigatorParameters: IMouseNavigatorParameters = {
    offsetDistance: NaN,
    defaultDistance: 0.5,
    defaultDistancePdfCameraParameter: 1600,
    defaultTiltAngle: 90 + EPS,
    defaultOrbitAngle: 180,
    isViewAllInDefaultPositionRequired: false,
};

const xComMouseNavigatorParameters: IMouseNavigatorParameters = {
    offsetDistance: 0,
    defaultDistance: ConfiguratorParameters.view.cameraDefaultDistance,
    defaultDistancePdfCameraParameter: ConfiguratorParameters.view.cameraDefaultDistancePdfCameraParameter,
    defaultTiltAngle: ConfiguratorParameters.view.cameraDefaultTilt,
    defaultOrbitAngle: ConfiguratorParameters.view.cameraDefaultPan,
    isViewAllInDefaultPositionRequired: true,
};
